import {
  FormControl,
  Input,
  InputGroup,
  InputLeftAddon,
  InputRightAddon,
  SimpleGrid,
} from '@chakra-ui/react'
import VitalStatsInputLabel from '../../../../components/VitalStatsInputLabel'
import { VitalStatsInputProps } from '../utils/types'

export const VitalStatsInputFields = ({
  stats,
  update,
  units,
}: VitalStatsInputProps) => {
  return (
    <SimpleGrid columns={[1, 2]} spacing={4}>
      <FormControl isRequired>
        <VitalStatsInputLabel
          url={
            'https://www.amazon.com/Hutchison-Medical-Patient-Lift-Scale/dp/B07CM7MVRC/ref=dp_fod_1?pd_rd_i=B07CM7MVRC&psc=1'
          }
          title='Weight'
          description='If you cannot use a standard scale, you can use a Hoyer Lift scale.'
        />
        <InputGroup>
          <Input
            type='number'
            step='any'
            value={stats.weight ?? ''}
            required
            onChange={(e) => {
              update({
                weight: parseFloat(e.target.value),
                units: units as any,
              })
            }}
          />
          <InputRightAddon>{units === 'metric' ? 'kg' : 'lbs'}</InputRightAddon>
        </InputGroup>
      </FormControl>
      <FormControl>
        <VitalStatsInputLabel
          url={
            'https://www.amazon.com/Innovo-Fingertip-Oximeter-Plethysmograph-Perfusion/dp/B077ZJ1ZKZ/ref=sr_1_17?crid=1P5F2YFM91549&keywords=nuvomed+pulse+oximeter+fingertip&qid=1652734395&sprefix=nuvo%2Caps%2C99&sr=8-17'
          }
          title='O2 Saturation'
          description='Measure your Oxygen Saturation with an Oximeter.'
        />
        <InputGroup>
          <Input
            type='number'
            step='any'
            min={0}
            max={100}
            value={stats.o2saturation ?? ''}
            onChange={(e) => {
              update({
                o2saturation: parseFloat(e.target.value),
              })
            }}
          />
          <InputRightAddon children='%' />
        </InputGroup>
      </FormControl>
      <FormControl>
        <VitalStatsInputLabel
          url={
            'https://www.amazon.com/Innovo-Fingertip-Oximeter-Plethysmograph-Perfusion/dp/B077ZJ1ZKZ/ref=sr_1_17?crid=1P5F2YFM91549&keywords=nuvomed+pulse+oximeter+fingertip&qid=1652734395&sprefix=nuvo%2Caps%2C99&sr=8-17'
          }
          title='Heart Rate'
          description='Measure your Heart Rate with an Oximeter.'
        />
        <InputGroup>
          <Input
            type='number'
            step='any'
            value={stats.heartRate ?? ''}
            onChange={(e) => {
              update({ heartRate: parseFloat(e.target.value) })
            }}
          />
          <InputRightAddon children='/minute' />
        </InputGroup>
      </FormControl>
      <FormControl>
        <VitalStatsInputLabel
          url={
            'https://www.amazon.com/Pressure-Monitor-Clinically-Validated-Eligible/dp/B0DN5ZMQ51/ref=sr_1_6?crid=1UYFSGEK3XN3G&dib=eyJ2IjoiMSJ9.htb36WUw3x6mqb3BbDTFOdzVw-HAwkbq2hwAwt1yOGJxbqdrSWwRopeuHyCIg0xWN4PUONM5G9aCCRhtYauAlbMbmeEWwZdq-jje-B4r-pT8Flg_1Albz5vqP1R2RQRpNHtgVEspNRsys-lCEjiaFj6D_MsPJ6-4JCXaZIR6htDi7H72cAtC1Qwybtr0nxa552KSlxm9lYvwdXQ3-ZAeFG5K2ZbZq8zUDZzsoKF794ukGDkoan4nh6xnQKBn4qxGyhedoKwXgoL8J9dDjeM5WoX1OlrsDVlhW6vDf3p06Uc9tEb1XQEqK9jXw-yr-nCwJhKc5RYfke_fArEP7TmsVZ4cdf5NDFqnWWxtt0HGgdE.zg6o79huhIPkzqhkmViPbLJODM7Q0TzF16poC9he2VI&dib_tag=se&keywords=blood%2Bpressure%2Bcuff%2Bautomatic&qid=1737765425&s=hpc&sprefix=blood%2Bpressure%2Bcuff%2Bautomatic%2Chpc%2C145&sr=1-6'
          }
          title='Blood Pressure'
        />
        <SimpleGrid columns={2} spacing={2}>
          <InputGroup>
            <InputLeftAddon fontSize='sm'>Systolic</InputLeftAddon>
            <Input
              type='number'
              step='any'
              value={stats.systolic ?? ''}
              onChange={(e) => {
                update({
                  systolic: parseFloat(e.target.value),
                })
              }}
            />
          </InputGroup>
          <InputGroup>
            <InputLeftAddon fontSize='sm'>Diastolic</InputLeftAddon>
            <Input
              type='number'
              step='any'
              value={stats.diastolic ?? ''}
              onChange={(e) => {
                update({
                  diastolic: parseFloat(e.target.value),
                })
              }}
            />
          </InputGroup>
        </SimpleGrid>
      </FormControl>
    </SimpleGrid>
  )
}
